/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import NewFooter from "./NewFooter";

export default NewFooter;
